import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import mainLogo from "../assets/images/Main-Logo.png";
import { useAuth } from "../context/AuthContext";
import { Modal } from "bootstrap";
import { useSelector } from "react-redux";

const Navbar = () => {
  const { t } = useTranslation();

  const { systemConfiguration } = useSelector((state) => state.commonStore);
  const language = localStorage.getItem("language");

  const token = localStorage.getItem("token");

  const { logOut } = useAuth();

  const location = useLocation();

  const [isActive, setIsActive] = useState(false);

  const onMenuClick = () => {
    setIsActive(!isActive);
  };

  const [isLangActive, setIsLangActive] = useState(false);

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark blue-bg fixed-top">
        <div className="container">
          <Link className="navbar-brand text-dark" to="/">
            <img src={systemConfiguration?.logo} alt="logo" className="img-fluid" />
            {/* Best Alert */}
          </Link>
          <button
            className={`navbar-toggler ${isActive ? "collapsed" : ""}`}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarContent"
            aria-controls="navbarContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={() => onMenuClick()}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className={`navbar-collapse collapse ${isActive ? "show" : ""}`}
            id="navbarContent"
          >
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a
                  className={`nav-link ${location.hash == "#home" ? "active" : ""
                    }`}
                  aria-current="page"
                  href={location?.pathname === "/" ? "#home" : "/bestalert/#home"}
                  onClick={() => onMenuClick()}
                >
                  {t("Home")}
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${location.hash == "#about" ? "active" : ""
                    }`}
                  href={location?.pathname === "/" ? "#about" : "/bestalert/#about"}
                  onClick={() => onMenuClick()}
                >
                  {t("About Us")}
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${location?.hash === "#services" ? "active" : ""}`}
                  href={location?.pathname === "/" ? "#services" : "/bestalert/#services"}
                  onClick={onMenuClick}
                >
                  {t("Services")}
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${location.hash == "#features" ? "active" : ""
                    }`}
                  href={location?.pathname === "/" ? "#features" : "/bestalert/#features"}
                  onClick={() => onMenuClick()}
                >
                  {t("Features")}
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${location.hash == "#faq" ? "active" : ""
                    }`}
                  href={location?.pathname === "/" ? "#faq" : "/bestalert/#faq"}
                  onClick={() => onMenuClick()}
                >
                  {t("Faqs")}
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${location.hash == "#testimonials" ? "active" : ""
                    }`}
                  href={location?.pathname === "/" ? "#testimonials" : "/bestalert/#testimonials"}
                  onClick={() => onMenuClick()}
                >
                  {t("Testimonials")}
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${location.hash == "#contact" ? "active" : ""
                    }`}
                  href={location?.pathname === "/" ? "#contact" : "/bestalert/#contact"}
                  onClick={() => onMenuClick()}
                >
                  {t("Contact")}
                </a>
              </li>
            </ul>
            <div className="nav-buttons d-flex gap-2">
              <div className="btn-group">
                <button
                  type="button"
                  className={`btn btn-outline-primary dropdown-toggle ${isLangActive ? "show" : ""
                    }`}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  id="dropdownMenuButton"
                  onClick={() => setIsLangActive(!isLangActive)}
                >
                  {language?.toUpperCase()}{" "}
                  <i className="fa fa-chevron-down"></i>
                </button>
                <ul
                  className={`dropdown-menu mt-5 ${isLangActive ? "show" : ""}`}
                  aria-labelledby="dropdownMenuButton"
                >
                  <li
                    className="dropdown-item btn"
                    onClick={() => {
                      localStorage.setItem("language", "en");
                      window.location.reload();
                      setIsLangActive(false);
                    }}
                  >
                    EN
                  </li>
                  <li
                    className="dropdown-item btn"
                    onClick={() => {
                      localStorage.setItem("language", "ar");
                      window.location.reload();
                      setIsLangActive(false);
                    }}
                  >
                    AR
                  </li>
                </ul>
              </div>
              {token ? (
                <>
                  <Link to="/dashboard" className="custom-btn main-btn2">
                    {/* {t("Dashboard")} */}
                    <i className="fa fa-user"></i>
                  </Link>
                  <button
                    type="button"
                    className="custom-btn main-btn"
                    onClick={() => logOut()}
                  >
                    {t("Logout")}
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login" className="custom-btn main-btn2">
                    {t("Login")}
                  </Link>
                  <Link to="/sign-up" className="custom-btn main-btn">
                    {t("Register")}
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </nav>

      
    </>
  );
};

export default Navbar;
